/**
 * Auto-generated file, please don't edit
 *
 * O'Web CLI 1.0.0
 *
 * Sun, 30 Jun 2019 14:02:22 GMT
 */

import Vue from "vue";
import BaseComponent from "./components/BaseComponent.vue";
import WAccountEdit from "./components/WAccountEdit.vue";
import WAccountEditPass from "./components/WAccountEditPass.vue";
import WAccountMenu from "./components/WAccountMenu.vue";
import WCaptcha from "./components/WCaptcha.vue";
import WChoicesEditor from "./components/WChoicesEditor.vue";
import WCompaniesList from "./components/WCompaniesList.vue";
import WCompaniesSearch from "./components/WCompaniesSearch.vue";
import WCompanyAbout from "./components/WCompanyAbout.vue";
import WCompanyAdd from "./components/WCompanyAdd.vue";
import WCompanyEdit from "./components/WCompanyEdit.vue";
import WCompanyMenu from "./components/WCompanyMenu.vue";
import WCompanyPicEdit from "./components/WCompanyPicEdit.vue";
import WCompanySurveys from "./components/WCompanySurveys.vue";
import WDialog from "./components/WDialog.vue";
import WDialogView from "./components/WDialogView.vue";
import WFreezer from "./components/WFreezer.vue";
import WHomeAbout from "./components/WHomeAbout.vue";
import WHomeMenu from "./components/WHomeMenu.vue";
import WLoader from "./components/WLoader.vue";
import WLoaderFull from "./components/WLoaderFull.vue";
import WMain from "./components/WMain.vue";
import WMenu from "./components/WMenu.vue";
import WNav from "./components/WNav.vue";
import WPage from "./components/WPage.vue";
import WPageError from "./components/WPageError.vue";
import WPicEditor from "./components/WPicEditor.vue";
import WQuestionEditor from "./components/WQuestionEditor.vue";
import WQuestionView from "./components/WQuestionView.vue";
import WSearchBox from "./components/WSearchBox.vue";
import WSectorAdd from "./components/WSectorAdd.vue";
import WSectorCompanies from "./components/WSectorCompanies.vue";
import WSectorEdit from "./components/WSectorEdit.vue";
import WSectorsList from "./components/WSectorsList.vue";
import WSplash from "./components/WSplash.vue";
import WSurveyAbout from "./components/WSurveyAbout.vue";
import WSurveyAdd from "./components/WSurveyAdd.vue";
import WSurveyAnswerView from "./components/WSurveyAnswerView.vue";
import WSurveyAnswers from "./components/WSurveyAnswers.vue";
import WSurveyAnswersUnsent from "./components/WSurveyAnswersUnsent.vue";
import WSurveyBuilder from "./components/WSurveyBuilder.vue";
import WSurveyEdit from "./components/WSurveyEdit.vue";
import WSurveyMenu from "./components/WSurveyMenu.vue";
import WSurveyRunner from "./components/WSurveyRunner.vue";
import WSurveyStats from "./components/WSurveyStats.vue";
import WSurveysList from "./components/WSurveysList.vue";
import WSurveysSearch from "./components/WSurveysSearch.vue";
import WUserAccountRecoveryOne from "./components/WUserAccountRecoveryOne.vue";
import WUserAccountRecoveryThree from "./components/WUserAccountRecoveryThree.vue";
import WUserAccountRecoveryTwo from "./components/WUserAccountRecoveryTwo.vue";
import WUserEdit from "./components/WUserEdit.vue";
import WUserEditPass from "./components/WUserEditPass.vue";
import WUserSignupOne from "./components/WUserSignupOne.vue";
import WUserSignupThree from "./components/WUserSignupThree.vue";
import WUserSignupTwo from "./components/WUserSignupTwo.vue";
import WUserView from "./components/WUserView.vue";
import WField from "./components/fields/WField.vue";
import WFieldButton from "./components/fields/WFieldButton.vue";
import WFieldCgu from "./components/fields/WFieldCgu.vue";
import WFieldCheckbox from "./components/fields/WFieldCheckbox.vue";
import WFieldFile from "./components/fields/WFieldFile.vue";
import WFieldHidden from "./components/fields/WFieldHidden.vue";
import WFieldImage from "./components/fields/WFieldImage.vue";
import WFieldInput from "./components/fields/WFieldInput.vue";
import WFieldPhone from "./components/fields/WFieldPhone.vue";
import WFieldRadio from "./components/fields/WFieldRadio.vue";
import WFieldRange from "./components/fields/WFieldRange.vue";
import WFieldSelect from "./components/fields/WFieldSelect.vue";
import WFieldSelect2 from "./components/fields/WFieldSelect2.vue";
import WFieldSubmit from "./components/fields/WFieldSubmit.vue";
import WFieldTextarea from "./components/fields/WFieldTextarea.vue";
import WForm from "./components/forms/WForm.vue";
import WFormCustom from "./components/forms/WFormCustom.vue";
import WFormX from "./components/forms/WFormX.vue";
import PAccount from "./components/pages/PAccount.vue";
import PCompany from "./components/pages/PCompany.vue";
import PHome from "./components/pages/PHome.vue";
import PSector from "./components/pages/PSector.vue";
import PSurvey from "./components/pages/PSurvey.vue";
import PAppUpdate from "./components/pages/oweb/PAppUpdate.vue";
import PUserAccountRecovery from "./components/pages/oweb/PUserAccountRecovery.vue";
import PUserEdit from "./components/pages/oweb/PUserEdit.vue";
import PUserLogin from "./components/pages/oweb/PUserLogin.vue";
import PUserLogout from "./components/pages/oweb/PUserLogout.vue";
import PUserPassEdit from "./components/pages/oweb/PUserPassEdit.vue";
import PUserPicEdit from "./components/pages/oweb/PUserPicEdit.vue";
import PUserSignup from "./components/pages/oweb/PUserSignup.vue";
import WQtypeBigtext from "./components/qtypes/WQtypeBigtext.vue";
import WQtypeBigtextView from "./components/qtypes/WQtypeBigtextView.vue";
import WQtypeCheckbox from "./components/qtypes/WQtypeCheckbox.vue";
import WQtypeCheckboxView from "./components/qtypes/WQtypeCheckboxView.vue";
import WQtypeRadio from "./components/qtypes/WQtypeRadio.vue";
import WQtypeRadioView from "./components/qtypes/WQtypeRadioView.vue";
import WQtypeText from "./components/qtypes/WQtypeText.vue";
import WQtypeTextView from "./components/qtypes/WQtypeTextView.vue";

Vue.component("BaseComponent",BaseComponent);
Vue.component("WAccountEdit",WAccountEdit);
Vue.component("WAccountEditPass",WAccountEditPass);
Vue.component("WAccountMenu",WAccountMenu);
Vue.component("WCaptcha",WCaptcha);
Vue.component("WChoicesEditor",WChoicesEditor);
Vue.component("WCompaniesList",WCompaniesList);
Vue.component("WCompaniesSearch",WCompaniesSearch);
Vue.component("WCompanyAbout",WCompanyAbout);
Vue.component("WCompanyAdd",WCompanyAdd);
Vue.component("WCompanyEdit",WCompanyEdit);
Vue.component("WCompanyMenu",WCompanyMenu);
Vue.component("WCompanyPicEdit",WCompanyPicEdit);
Vue.component("WCompanySurveys",WCompanySurveys);
Vue.component("WDialog",WDialog);
Vue.component("WDialogView",WDialogView);
Vue.component("WFreezer",WFreezer);
Vue.component("WHomeAbout",WHomeAbout);
Vue.component("WHomeMenu",WHomeMenu);
Vue.component("WLoader",WLoader);
Vue.component("WLoaderFull",WLoaderFull);
Vue.component("WMain",WMain);
Vue.component("WMenu",WMenu);
Vue.component("WNav",WNav);
Vue.component("WPage",WPage);
Vue.component("WPageError",WPageError);
Vue.component("WPicEditor",WPicEditor);
Vue.component("WQuestionEditor",WQuestionEditor);
Vue.component("WQuestionView",WQuestionView);
Vue.component("WSearchBox",WSearchBox);
Vue.component("WSectorAdd",WSectorAdd);
Vue.component("WSectorCompanies",WSectorCompanies);
Vue.component("WSectorEdit",WSectorEdit);
Vue.component("WSectorsList",WSectorsList);
Vue.component("WSplash",WSplash);
Vue.component("WSurveyAbout",WSurveyAbout);
Vue.component("WSurveyAdd",WSurveyAdd);
Vue.component("WSurveyAnswerView",WSurveyAnswerView);
Vue.component("WSurveyAnswers",WSurveyAnswers);
Vue.component("WSurveyAnswersUnsent",WSurveyAnswersUnsent);
Vue.component("WSurveyBuilder",WSurveyBuilder);
Vue.component("WSurveyEdit",WSurveyEdit);
Vue.component("WSurveyMenu",WSurveyMenu);
Vue.component("WSurveyRunner",WSurveyRunner);
Vue.component("WSurveyStats",WSurveyStats);
Vue.component("WSurveysList",WSurveysList);
Vue.component("WSurveysSearch",WSurveysSearch);
Vue.component("WUserAccountRecoveryOne",WUserAccountRecoveryOne);
Vue.component("WUserAccountRecoveryThree",WUserAccountRecoveryThree);
Vue.component("WUserAccountRecoveryTwo",WUserAccountRecoveryTwo);
Vue.component("WUserEdit",WUserEdit);
Vue.component("WUserEditPass",WUserEditPass);
Vue.component("WUserSignupOne",WUserSignupOne);
Vue.component("WUserSignupThree",WUserSignupThree);
Vue.component("WUserSignupTwo",WUserSignupTwo);
Vue.component("WUserView",WUserView);
Vue.component("WField",WField);
Vue.component("WFieldButton",WFieldButton);
Vue.component("WFieldCgu",WFieldCgu);
Vue.component("WFieldCheckbox",WFieldCheckbox);
Vue.component("WFieldFile",WFieldFile);
Vue.component("WFieldHidden",WFieldHidden);
Vue.component("WFieldImage",WFieldImage);
Vue.component("WFieldInput",WFieldInput);
Vue.component("WFieldPhone",WFieldPhone);
Vue.component("WFieldRadio",WFieldRadio);
Vue.component("WFieldRange",WFieldRange);
Vue.component("WFieldSelect",WFieldSelect);
Vue.component("WFieldSelect2",WFieldSelect2);
Vue.component("WFieldSubmit",WFieldSubmit);
Vue.component("WFieldTextarea",WFieldTextarea);
Vue.component("WForm",WForm);
Vue.component("WFormCustom",WFormCustom);
Vue.component("WFormX",WFormX);
Vue.component("PAccount",PAccount);
Vue.component("PCompany",PCompany);
Vue.component("PHome",PHome);
Vue.component("PSector",PSector);
Vue.component("PSurvey",PSurvey);
Vue.component("PAppUpdate",PAppUpdate);
Vue.component("PUserAccountRecovery",PUserAccountRecovery);
Vue.component("PUserEdit",PUserEdit);
Vue.component("PUserLogin",PUserLogin);
Vue.component("PUserLogout",PUserLogout);
Vue.component("PUserPassEdit",PUserPassEdit);
Vue.component("PUserPicEdit",PUserPicEdit);
Vue.component("PUserSignup",PUserSignup);
Vue.component("WQtypeBigtext",WQtypeBigtext);
Vue.component("WQtypeBigtextView",WQtypeBigtextView);
Vue.component("WQtypeCheckbox",WQtypeCheckbox);
Vue.component("WQtypeCheckboxView",WQtypeCheckboxView);
Vue.component("WQtypeRadio",WQtypeRadio);
Vue.component("WQtypeRadioView",WQtypeRadioView);
Vue.component("WQtypeText",WQtypeText);
Vue.component("WQtypeTextView",WQtypeTextView);
